// Access runtime environment variables through the window.APP_ENV object
export function getEnvironmentVariable(name) {
  // First check for runtime injected variables from OTK
  if (window.APP_ENV && window.APP_ENV[name]) {
    return window.APP_ENV[name];
  }
  
  // Fall back to build-time variables for local development
  return process.env[name];
}

export function getBackendUrl() {
  return getEnvironmentVariable('REACT_APP_HOOVER_BACKEND_BASE_URL');
}


// WEBPACK FOOTER //
// ./src/env.js